// Tiny DOM helpers — no framework needed for a 3-screen app.

export const app = (): HTMLElement => {
  const el = document.getElementById("app");
  if (!el) throw new Error("#app not found");
  return el;
};

export function render(html: string): HTMLElement {
  const root = app();
  root.innerHTML = html;
  return root;
}

export function $(selector: string, scope: ParentNode = document): HTMLElement {
  const el = scope.querySelector(selector);
  if (!el) throw new Error(`Element not found: ${selector}`);
  return el as HTMLElement;
}

let toastTimer: number | undefined;
export function toast(message: string, ms = 2200): void {
  document.querySelector(".toast")?.remove();
  const el = document.createElement("div");
  el.className = "toast";
  el.textContent = message;
  document.body.appendChild(el);
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => el.remove(), ms);
}

export function shareLink(code: string): string {
  return `${location.origin}/?call=${encodeURIComponent(code)}`;
}
